import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import subscription from './modules/subscription'
import users from './modules/users'
import clients from './modules/clients'
import faxChannels from './modules/faxChannels'
import subscriptionClasses from './modules/subscriptionClasses'
import resellers from './modules/resellers'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        auth,
        subscription,
        users,
        clients,
        faxChannels,
        subscriptionClasses,
        resellers
    },
    strict: debug
})